import { handleActions } from 'redux-actions';
import {
  AccountActionsEnum,
  FetchReferer,
  FetchRefererError,
  FetchRefererSuccess,
} from '../actions';
import { Referer } from '../models';

export interface IState {
  referer: Referer;
  referralCode: string;
  loaded: boolean;
  loading: boolean;
  error: any;
}

export const initialState: IState = {
  referer: null,
  referralCode: null,
  loading: false,
  loaded: false,
  error: null,
};

const reducerFn = handleActions(
  {
    [AccountActionsEnum.FETCH_REFERER]: function (
      state: IState,
      { payload }: FetchReferer
    ) {
      return {
        ...state,
        referralCode: payload.referralCode,
        loading: true,
        loaded: false,
      };
    },
    [AccountActionsEnum.FETCH_REFERER_SUCCESS]: function (
      state: IState,
      { payload }: FetchRefererSuccess
    ) {
      return {
        ...state,
        loading: false,
        loaded: true,
        referer: payload.referer,
        error: null,
      };
    },
    [AccountActionsEnum.FETCH_REFERER_ERROR]: function (
      state: IState,
      { payload }: FetchRefererError
    ) {
      return {
        ...state,
        loading: false,
        loaded: false,
        referer: null,
        referralCode: null,
        error: payload.error,
      };
    },
  } as any,
  initialState
);

export function reducer(state: IState, action: any) {
  return reducerFn(state, action);
}
